import React from "react";
import { Link } from "react-router-dom";
import Logo from "../../Assets/Images/logo.png";

const Header = () => {
  return (
    <header>
      <div className="container">
        <nav className="navbar navbar-expand-md">
          <a className="navbar-brand" href="#">
            <div className="logo-img">
              <Link to="/">
                {" "}
                <img src={Logo} />
              </Link>
            </div>
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#collapsibleNavbar"
          >
            <span className="navbar-toggler-icon">
              <i class="fas fa-bars"></i>
            </span>
          </button>
          <div className="collapse navbar-collapse" id="collapsibleNavbar">
            <ul className="navbar-nav">
              <li className="nav-item">
                <Link to="/about" className="nav-link">
                  About
                </Link>
              </li>
              {/* <li className="nav-item">
                <Link to="/blog" className="nav-link">
                  Blog
                </Link>
              </li> */}
              <li className="nav-item">
                <Link to="/contact" className="nav-link">
                  Contact Us
                </Link>
              </li>
              <li className="nav-item">
                <a href="http://intransit-test.s3-website.ap-south-1.amazonaws.com/login?user=customer" target="_blank">
                  <button className="yellow-btn">Login</button>
                </a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
